<template>
  <div class="content">
    <form action="" @submit.prevent="updateCin">
      <div class="md-layout md-size-100">
        <md-toolbar :md-elevation="1" md-xlarge-size-33>
          <span class="md-title">Čin negiranja</span>
        </md-toolbar>

        <md-field>
          <label>Naslov</label>
          <md-input v-model="working_entry.cin.cin_naslov"></md-input>
        </md-field>

        <md-field>
          <label>Link</label>
          <md-input v-model="working_entry.cin.cin_link"></md-input>
        </md-field>

        <md-field>
          <label>Opis</label>
          <md-textarea
            v-model="working_entry.cin.cin_citat_opis"
            md-autogrow
          ></md-textarea>
        </md-field>

        <md-field>
          <label for="nacin">Nacin negiranja</label>
          <md-select
            v-model="working_entry.cin.cin_nacin_negiranja"
            name="nacin"
            id="nacin"
            placeholder="Nacin negiranja"
          >
            <md-option value="Prizivanje novog genocida"
              >Prizivanje novog genocida</md-option
            >
            <md-option value="Trijumfalizam - slavljenje genocida koji se desio"
              >Trijumfalizam - slavljenje genocida koji se desio</md-option
            >
            <md-option value="Aktivno poricanje / negiranje"
              >Aktivno poricanje / negiranje</md-option
            >
            <md-option value="Priznavanje zločina ali ne i genocida"
              >Priznavanje zločina ali ne i genocida</md-option
            >
            <md-option
              value="Relativizacija (opravdavanje i/ili poređenje sa drugim ratnim zločinima)"
              >Relativizacija (opravdavanje i/ili poređenje sa drugim ratnim
              zločinima)</md-option
            >
            <md-option
              value="Podrška počiniteljima (ne mora se eksplicitno spominjati genocid)"
              >Podrška počiniteljima (ne mora se eksplicitno spominjati
              genocid)</md-option
            >
            <md-option value="Odbijanje / ignorisanje teme"
              >Odbijanje / ignorisanje teme</md-option
            >
          </md-select>
        </md-field>

        <md-field>
          <label for="nacin">Država</label>
          <md-select
            v-model="working_entry.cin.cin_drzava"
            name="cin_drzava"
            id="cin_drzava"
            placeholder="Država"
          >
            <md-option value="Bosna i Hercegovina"
              >Bosna i Hercegovina</md-option
            >
            <md-option value="Bosna i Hercegovina - RS"
              >Bosna i Hercegovina - RS</md-option
            >
            <md-option value="Bosna i Hercegovina - FBiH"
              >Bosna i Hercegovina - FBiH</md-option
            >
            <md-option value="Bosna i Hercegovina - BD"
              >Bosna i Hercegovina - BD</md-option
            >
            <md-option value="Republika Srbija">Republika Srbija</md-option>
            <md-option value="Crna Gora ili Hrvatska"
              >Crna Gora ili Hrvatska</md-option
            >
            <md-option value="Ostale države iz regije"
              >Ostale države iz regije</md-option
            >
            <md-option value="Ostale države">Ostale države</md-option>
          </md-select>
        </md-field>

        <md-divider></md-divider>
      </div>

      <div class="md-layout md-size-100">
        <md-toolbar :md-elevation="1">
          <span class="md-title md-size-33">Podaci o negatoru</span>

          <div id="select_edit_negator" class="md-size-66">          
            <div class="md-layout-item md-size-66">
              <md-field>
                <label for="rod" style="color: #ffffff !important">Odaberite negatora</label>
                <md-select
                  v-model="working_entry.cin.negator_id"
                >
                  <md-option v-for="item in negators_list" v-bind:key="item.id" v-bind:value="item.id">{{ item.negator_ime_naziv }}</md-option>
                </md-select>
              </md-field>
            </div>
            <md-switch v-model="akter_locked"><label v-if="akter_locked">Editovanje je trenutno ugašeno</label><label v-else>Editovanje je trenutno upaljeno</label></md-switch>
          </div>

        <div class="md-layout ">
          <md-button class="md-dense md-raised md-primary"
            v-on:click="add_new_negator">Dodaj novog negatora</md-button
          >
        </div>

        <div class="md-layout ">
          <md-button class="md-dense md-raised md-primary"
            v-on:click="post_new_negator">Spasi novog negatora</md-button
          >
        </div>
        <div class="md-layout ">
          <md-button class="md-dense md-raised md-primary"
            v-on:click="update_negator">Spasi izmjene na negatoru</md-button
          >
        </div>
        </md-toolbar>
        


        <div class="md-layout-item md-size-100">
          <md-field>
            <label>Ime Negatora</label>
            <md-input
              v-model="working_entry.negator.negator_ime_naziv"
              :disabled="akter_locked"
            ></md-input>
          </md-field>
        </div>

        <div class="md-layout-item md-size-100">
          <md-field>
            <label>Opis Negatora</label>
            <md-input v-model="working_entry.negator.negator_opis" :disabled="akter_locked"></md-input>
          </md-field>
        </div>
        <div class="md-layout-item md-size-33">
          <md-field>
            <label for="rod">Rod Negatora</label>
            <md-select
              v-model="working_entry.negator.negator_rod"
              name="negator_rod"
              id="negator_rod"
              placeholder="Rod"
              :disabled="akter_locked"
            >
              <md-option value="M">M</md-option>
              <md-option value="Ž">Ž</md-option>
            </md-select>
          </md-field>
        </div>

        <div class="md-layout-item md-size-33">
          <md-field>
            <label for="negator_financiranje">Izvor Financiranja</label>
            <md-select
              v-model="working_entry.negator.negator_financiranje"
              name="negator_financiranje"
              id="negator_financiranje"
              :disabled="akter_locked"
            >
              <md-option value="Poznato: Javna sredstva"
                >Poznato: Javna sredstva</md-option
              >
              <md-option value="Poznato: Donacije">Poznato: Donacije</md-option>
              <md-option value="Poznato: Komercijalno"
                >Poznato: Komercijalno</md-option
              >
              <md-option value="NA">Nepoznato</md-option>
              <md-option value="Nepoznato">Nepoznato</md-option>
            </md-select>
          </md-field>
        </div>

        <div class="md-layout-item md-size-33">
          <md-field>
            <label for="negator_drzava">Država Negatora</label>
            <md-select
              v-model="working_entry.negator.negator_drzava"
              name="negator_drzava"
              id="negator_drzava"
              placeholder="negator_drzava"
              :disabled="akter_locked"
            >
              <md-option value="Bosna i Hercegovina"
                >Bosna i Hercegovina</md-option
              >
              <md-option value="Bosna i Hercegovina - RS"
                >Bosna i Hercegovina - RS</md-option
              >
              <md-option value="Bosna i Hercegovina - FBiH"
                >Bosna i Hercegovina - FBiH</md-option
              >
              <md-option value="Bosna i Hercegovina - BD"
                >Bosna i Hercegovina - BD</md-option
              >
              <md-option value="Republika Srbija">Republika Srbija</md-option>
              <md-option value="Crna Gora ili Hrvatska"
                >Crna Gora ili Hrvatska</md-option
              >
              <md-option value="Ostale države iz regije"
                >Ostale države iz regije</md-option
              >
              <md-option value="Ostale države">Ostale države</md-option>
            </md-select>
          </md-field>
        </div>

        <div class="md-layout-item">
          <md-field>
            <label for="negator_sektor">Sektor Negatora</label>
            <md-select
              v-model="working_entry.negator.negator_sektor"
              name="negator_sektor"
              id="negator_sektor"
              placeholder="negator_sektor"
              :disabled="akter_locked"
            >
              <md-option value="Javni (državni)">Javni (državni)</md-option>
              <md-option value="Komercijalni (privatni)"
                >Komercijalni (privatni)</md-option
              >
              <md-option value="Neprofitni">Neprofitni</md-option>
              <md-option value="NA">NA</md-option>
            </md-select>
          </md-field>
        </div>

        <div class="md-layout-item">
          <md-field>
            <label for="negator_karakteristike">Karakteristike Negatora</label>
            <md-select
              v-model="working_entry.negator.negator_karakteristike"
              name="negator_karakteristike"
              id="negator_karakteristike"
              placeholder="negator_karakteristike"
              :disabled="akter_locked"
            >
              <md-option value="Zvaničnik/ca izvršne vlasti"
                >Zvaničnik/ca izvršne vlasti</md-option
              >
              <md-option value="Zvaničnik/ca zakonodavne vlasti"
                >Zvaničnik/ca zakonodavne vlasti</md-option
              >
              <md-option value="Zvaničnik/ca pravosuđe"
                >Zvaničnik/ca pravosuđe</md-option
              >
              <md-option value="Javni/a službenik/ca"
                >Javni/a službenik/ca</md-option
              >
              <md-option value="Privatno lice">Privatno lice</md-option>
              <md-option value="Javna ličnost">Javna ličnost</md-option>
              <md-option value="Institucija">Institucija</md-option>
              <md-option value="Organizacija">Organizacija</md-option>
              <md-option value="Neformalna grupa">Neformalna grupa</md-option>
              <md-option value="Medij">Medij</md-option>
              <md-option value="Religijska ustanova"
                >Religijska ustanova</md-option
              >
            </md-select>
          </md-field>
        </div>

        <div class="md-layout-item md-size-100">
          <md-field>
            <label>Uloga u Ratu Negatora</label>
            <md-input
              :disabled="akter_locked"
              v-model="working_entry.negator.negator_uloga_u_ratu"
            ></md-input>
          </md-field>
        </div>
      </div>

      <div class="md-layout md-size-100">
          <md-toolbar :md-elevation="1">
            <span class="md-title md-size-33">Podaci o platformi</span>
            <div class="md-layout-item md-size-33">
              <md-field>
                <label for="rod" style="color: #ffffff !important">Odaberite platformu</label>
                <md-select
                  v-model="working_entry.cin.platform_id"
                >
                  <md-option v-for="item in platforms_list" v-bind:key="item.id" v-bind:value="item.id">{{ item.platforma_naziv }}</md-option>
                </md-select>
              </md-field>
            </div>
            <md-switch v-model="platform_locked"><label v-if="platform_locked">Editovanje je trenutno ugašeno</label><label v-else>Editovanje je trenutno upaljeno</label></md-switch>

        <div class="md-layout ">
          <md-button class="md-dense md-raised md-primary"
            v-on:click="add_new_platform">Dodaj novu platformu</md-button
          >
        </div>

        <div class="md-layout ">
          <md-button class="md-dense md-raised md-primary"
            v-on:click="post_new_platform">Spasi novu platformu</md-button
          >
        </div>
        <div class="md-layout ">
          <md-button class="md-dense md-raised md-primary"
            v-on:click="update_platform">Spasi izmjene na platformi</md-button
          >
        </div>
        </md-toolbar>


          <div class="md-layout-item md-size-100">
            <md-field>
              <label>Naziv Platforme</label>
              <md-input
                v-model="working_entry.platforma.platforma_naziv"
                :disabled="platform_locked"
              ></md-input>
            </md-field>
          </div>

          <div class="md-layout-item md-size-100">
            <md-field>
              <label>Opis Platforme</label>
              <md-input
                v-model="working_entry.platforma.platforma_opis"
                :disabled="platform_locked"
              ></md-input>
            </md-field>
          </div>

          <div class="md-layout-item">
            <md-field>
              <label for="platforma_lokacija">Platforma Lokacija</label>
              <md-select
                v-model="working_entry.platforma.platforma_lokacija"
                name="platforma_lokacija"
                id="platforma_lokacija"
                placeholder="platforma_lokacija"
                :disabled="platform_locked"
              >
                <md-option value="Bosna i Hercegovina"
                  >Bosna i Hercegovina</md-option
                >
                <md-option value="Bosna i Hercegovina - RS"
                  >Bosna i Hercegovina - RS</md-option
                >
                <md-option value="Bosna i Hercegovina - FBiH"
                  >Bosna i Hercegovina - FBiH</md-option
                >
                <md-option value="Bosna i Hercegovina - BD"
                  >Bosna i Hercegovina - BD</md-option
                >
                <md-option value="Republika Srbija">Republika Srbija</md-option>
                <md-option value="Crna Gora ili Hrvatska"
                  >Crna Gora ili Hrvatska</md-option
                >
                <md-option value="Ostale države iz regije"
                  >Ostale države iz regije</md-option
                >
                <md-option value="Ostale države">Ostale države</md-option>
              </md-select>
            </md-field>
          </div>

          <div class="md-layout-item">
            <md-field>
              <label for="platforma_financiranje_sektor"
                >Izvor Financiranja Platforme</label
              >
              <md-select
                v-model="working_entry.platforma.platforma_financiranje_sektor"
                name="platforma_financiranje_sektor"
                id="platforma_financiranje_sektor"
                :disabled="platform_locked"
              >
                <md-option value="Poznato: Javna sredstva"
                  >Poznato: Javna sredstva</md-option
                >
                <md-option value="Poznato: Donacije"
                  >Poznato: Donacije</md-option
                >
                <md-option value="Poznato: Komercijalno"
                  >Poznato: Komercijalno</md-option
                >
                <md-option value="NA">Nepoznato</md-option>
                <md-option value="Nepoznato">Nepoznato</md-option>
              </md-select>
            </md-field>
          </div>
          <div class="md-layout-item">
            <md-field>
              <label for="platforma_tip_medija">Tip Medija</label>
              <md-select
                v-model="working_entry.platforma.platforma_tip_medija"
                name="platforma_tip_medija"
                id="platforma_tip_medija"
                :disabled="platform_locked"
              >
                <md-option value="Javna novinska agencija"
                  >Javna novinska agencija</md-option
                >
                <md-option value="Javna RTV">Javna RTV</md-option>
                <md-option value="Komercijalna novinska agencija"
                  >Komercijalna novinska agencija</md-option
                >
                <md-option value="Komercijalni medij"
                  >Komercijalni medij</md-option
                >
                <md-option value="Anonimna web stranica"
                  >Anonimna web stranica</md-option
                >
                <md-option value="Društvene mreže">Društvene mreže</md-option>
                <md-option value="Naučni rad">Naučni rad</md-option>
                <md-option value="Knjiga">Knjiga</md-option>
                <md-option value="Ostalo">Ostalo</md-option>
              </md-select>
            </md-field>
          </div>
        </div>
        <div class="md-layout">
          <md-button type="submit" class="md-dense md-raised md-primary"
            >Spasi Izmjene</md-button
          >
        </div>
      
    </form>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: "TextFields",
  methods: {
    add_new_negator(event)
    {
      this.working_entry.negator = {
          uuid_negator: "",
          negator_financiranje: "",
          negator_drzava: "",
          negator_ime_naziv: "",
          negator_oblast: "",
          negator_rod: "",
          negator_sektor: "",
          negator_karakteristike: "",
          negator_uloga_u_ratu: ""
          }
      this.akter_locked = false
    },
    add_new_platform(event)
    {
      this.working_entry.platforma = {
      platforma_lokacija: "",
      platforma_opis: "?",
      platforma_tip_medija: "",
      uuid_platforma: "",
      platforma_financiranje_sektor: "",
      platforma_naziv: "",
      }
    },
    async post_new_negator(event){      
      const token = await this.$auth.getTokenSilently()
      this.new_negator = this.working_entry.negator;
      const headers = {
        "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
      };

      axios
        .post(
          "https://hxy5npx7g6.execute-api.eu-west-1.amazonaws.com/negatori",
          this.new_negator,
          {
            headers: headers,
          }
        )
        .then((response) => {
          if (response.status == 200) {
            this.working_entry.negator = response["EntryWritten"];
          } else {
            this.apiMessage =
              "Ima neka greška u formularu ili sajtu, pritisni CTRL i F5 da tvrdi regresh, ako ovo nastavi javite se na imer91@gmail.com";
          }
          
        })
        .catch((error) => {
          
        });

    },
    async update_negator(event) {
      const token = await this.$auth.getTokenSilently()

      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`

      };

      if(this.working_entry.negator.uuid_negator == "")
      {
        //error response
        // toast this akter doesn't exist in the DB, please save first, then you can update
      }
      else{
        
      axios
        .patch(
          "https://hxy5npx7g6.execute-api.eu-west-1.amazonaws.com/negatori/"+this.working_entry.negator.uuid_negator,
          this.working_entry.negator,
          {
            headers: headers,
          }
        )
        .then((response) => {
          if (response.status == 200) {
            //this.working_entry.negator = response["EntryWritten"];
          } else {
            this.apiMessage =
              "Ima neka greška u formularu ili sajtu, pritisni CTRL i F5 da tvrdi regresh, ako ovo nastavi javite se na imer91@gmail.com";
          }
          
        })
        .catch((error) => {
          
        });
      }
    },
    async post_new_platform(event)
    {
      const token = await this.$auth.getTokenSilently()
      this.new_platform = this.working_entry.platforma;
      const headers = {
        "Content-Type": "application/json",          
        Authorization: `Bearer ${token}`

      };

      axios
        .post(
          "https://hxy5npx7g6.execute-api.eu-west-1.amazonaws.com/platforme",
          this.new_platform,
          {
            headers: headers,
          }
        )
        .then((response) => {
          if (response.status == 200) {
            this.working_entry.platforma = response["EntryWritten"];
          } else {
            this.apiMessage =
              "Ima neka greška u formularu ili sajtu, pritisni CTRL i F5 da tvrdi regresh, ako ovo nastavi javite se na imer91@gmail.com";
          }
          
        })
        .catch((error) => {
          
        });
    },
    async update_platform(event)
    {
      const token = await this.$auth.getTokenSilently()
        const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`

      };

      if(this.working_entry.platforma.uuid_platforma == "")
      {
        //error response
        // toast this akter doesn't exist in the DB, please save first, then you can update
      }
      else{
      axios
        .patch(
          "https://hxy5npx7g6.execute-api.eu-west-1.amazonaws.com/platforme/"+this.working_entry.platforma.uuid_platforma,
          this.working_entry.platforma,
          {
            headers: headers,
          }
        )
        .then((response) => {
          if (response.status == 200) {
            //this.working_entry.negator = response["EntryWritten"];
          } else {
            this.apiMessage =
              "Ima neka greška u formularu ili sajtu, pritisni CTRL i F5 da tvrdi regresh, ako ovo nastavi javite se na imer91@gmail.com";
          }
          
        })
        .catch((error) => {
          
        });  
      }
      
    }
  },
  data: () => ({
    initial: "Initial Value",
    type: null,
    withLabel: null,
    inline: null,
    number: null,
    textarea: null,
    autogrow: null,
    disabled: null,
    working_cin:{},
    working_negator:{},
    working_platforma:{},
    active_entry: {},
    working_entry: {
      // data copied over to this one from form, this is the form model
      cin: {},
      negator: {},
      platforma: {},
    },
    test_entry: {
      cin_nacin_negiranja: "Aktivno poricanje / negiranje",
      cin_datum: "1594159200000",
      uuid_cin: "3cdd55a9-0a0a-4a63-a70a-f9d2cf315a75",
      platform_id: "889e71e0-38ec-4de5-a55f-9e059040cae9",
      negator_id: "9a8cc2fd-ea25-494f-8e32-2b645ce54ba0",
      cin_drzava: "Republika Srbija",
      cin_naslov:
        "ISTORI\u010cAR IVANI\u0160EVI\u0106 Analiza otkrila brojne obmane o Srebrenici! Nisu stradali muslimanski civili, samo se stvara mr\u017enja",
      cin_link:
        "https://www.kurir.rs/region/bosna-i-hercegovina/3493995/istoricar-ivanisevic-analiza-otkrila-brojne-obmane-o-srebrenici-nisu-stradali-muslimanski-civili-samo-se-stvara-mrznja",
      cin_citat_opis:
        'Poznati srpski istori\u010dar i istra\u017eiva\u010d, Milivoje Ivani\u0161evi\u0107, rekao je da je analiza veoma obimne dokumentacije, koju je sproveo, omogu\u0107ila identifikaciju \u010dinjenica i otkrivanje brojnih obmana i falsifikata, \u0161to je otvorilo i pitanje do kada \u0107e se na falsifikatima o Srebrenici podgrevati mr\u017enja prema srpskom narodu.\n"Dokazivao sam da nisu stradali muslimanski civili. \u010cak, naprotiv, stradali su jedino civili srpske nacionalnosti", nagla\u0161ava Ivani\u0161evi\u0107.\n\n\u010cITAV TEKST GOVORI O SREBRENICI \n',
      uuid_negator: "9a8cc2fd-ea25-494f-8e32-2b645ce54ba0",
      negator_financiranje: "NA",
      negator_drzava: "Republika Srbija",
      negator_ime_naziv: "Milivoje Ivani\u0161evi\u0107",
      negator_oblast: "Visoko obrazovanje",
      negator_rod: "M",
      negator_sektor: "NA",
      negator_karakteristike: "Javna li\u010dnost",
      negator_uloga_u_ratu: "NA",
      platforma_lokacija: "Republika Srbija",
      platforma_opis: "?",
      platforma_tip_medija: "Komercijalni medij",
      uuid_platforma: "889e71e0-38ec-4de5-a55f-9e059040cae9",
      platforma_financiranje_sektor: "Poznato: Komercijalno",
      platforma_naziv: "Kurir",
    },
    akter_locked: true,
    platform_locked: true,
    all_platforms:{},
    all_negatori:{},
    adding_new_negator: false,
    adding_new_platform: false,
    new_negator: {
      uuid_negator: "",
      negator_financiranje: "",
      negator_drzava: "",
      negator_ime_naziv: "",
      negator_oblast: "",
      negator_rod: "",
      negator_sektor: "",
      negator_karakteristike: "",
      negator_uloga_u_ratu: ""
    },
    new_platform: {
      platforma_lokacija: "",
      platforma_opis: "?",
      platforma_tip_medija: "",
      uuid_platforma: "",
      platforma_financiranje_sektor: "",
      platforma_naziv: "",
    }
  }),
  mounted: async function () {
    const token = await this.$auth.getTokenSilently()
  axios
      .get("https://hxy5npx7g6.execute-api.eu-west-1.amazonaws.com/cinovi/"+ this.$route.params.id,
      {headers:{Authorization: `Bearer ${token}`}})
      .then(response => (this.working_entry = response.data));
    Object.assign(this.working_entry, this.active_entry);

  axios
    .get("https://hxy5npx7g6.execute-api.eu-west-1.amazonaws.com/negatori",
    {headers:{Authorization: `Bearer ${token}`}})
    .then(response => (this.all_negatori = response.data.Items))

  axios
  .get("https://hxy5npx7g6.execute-api.eu-west-1.amazonaws.com/platforme",
    {headers:{Authorization: `Bearer ${token}`}})
  .then(response => (this.all_platforms = response.data.Items))  
  },
  computed: {
    platforms_dict: function()
    {
      let new_dict = {}
      this.all_platforms.forEach(function(item)
            {
        new_dict[item.uuid_platforma] = item
            });
      return new_dict
    },
    negatori_dict: function()
    {
      let new_dict = {}
      this.all_negatori.forEach(function(item)
            {
        new_dict[item.uuid_negator] = item
            });
      return new_dict
    },
    platforms_list: function()
    {
      let new_list = [];
      this.all_platforms.forEach(function(item)
      {
        var q = {"id": item.uuid_platforma, "platforma_naziv":item.platforma_naziv}
        new_list.push(q)
      });
      new_list.sort((a,b) => (a.platforma_naziv > b.platforma_naziv) ? 1 : ((b.platforma_naziv > a.platforma_naziv) ? -1 : 0));
      return new_list
    },
    negators_list: function()
    {
      let new_list = [];
      this.all_negatori.forEach(function(item)
      {
        var q = {"id": item.uuid_negator, "negator_ime_naziv":item.negator_ime_naziv}
        new_list.push(q)
      });
      new_list.sort((a,b) => (a.negator_ime_naziv > b.negator_ime_naziv) ? 1 : ((b.negator_ime_naziv > a.negator_ime_naziv) ? -1 : 0));
      return new_list
    },
    active_negator: function()
    {
      return this.working_entry.cin.negator_id
    },
    active_platform: function(){
      return this.working_entry.cin.platform_id
    }
  },
  watch: {
    active_negator: function () 
    {
      this.working_entry.negator = this.negatori_dict[this.active_negator]
    },
    active_platform: function()
    {
      this.working_entry.platforma = this.platforms_dict[this.active_platform]
    }
  }

};
</script>